export const buttonAddonData = [
    {
      text: "Multiple add-ons are supported and can be mixed with buttons input versions.",
    },
  ];
  
  export const customFormData = [
    {
      text: "Input groups include support for ",
      code: "custom selects and custom file inputs",
    },
    {
      text: ". Browser default versions of these are not supported.",
    },
  ];
  
  export const pixelData = ["Tivo", "Cuba", "Roxo"];
  
  export const colorData  = ["Yellow", "Red", "Orange"];
  
  export const chocolateData = ["Dark Chocolates", "Dairy Milk", "Kitkat"];
  
  export const favoriteThemeData = ["Oslo", "Koho", "Voxo"];
  
  export const customFileInputData = [
    {
      text: "Input groups include support for custom selects and custom ",
      code: "file uploads",
    },
    {
      text: ". Browser default versions of these are not supported.",
    },
  ];
  
  export const buttonWithDropdownData = [
    {
      text: "Use the",
      code: ".input-group ",
    },
    {
      text: "and ",
      code: "[aria-label='']",
    },
    {
      text: " through buttons with dropdowns",
    },
  ];
  
  export const buttonWithDropOne = ["Ecommerce", "Email", "Users", "Bookmarks"];
  
  export const buttonWithDropTwo = ["Starter kit", "Gallery", "Blog", "Maps"];
  
  export const buttonWithDropThird = ["Widgets", "Project", "Contacts", "Tasks"];
  
  export const buttonWithDropForth = ["To-Do", "FAQ", "Knowledgebase", "Support Ticket"];
  
  export const segmentButtonData = [
    {
      text: "Multiple add-ons are supported and can be mixed with",
      code: " dropdowns",
    },
    {
      text: " versions.",
    },
  ];
  
  export const segmentDataOne = ["Learning", "Editors", "Users", "Social App"];
  
  export const segmentDataTwo = ["Search Result", "Tasks", "Projects", "Animation"];
  
  export const checkAndRadioData = [
    {
      text: "Place any checkbox or radio option within an input group's addon instead of text. We recommend adding ",
      code: ".mt-0",
    },
    {
      text: " to the ",
      code: ".form-check-input",
    },
    {
      text: " when there's no visible text next to the input.",
    },
  ];

  export const sizingDatas = [
    {
      text: "Add the relative form sizing classes to the",
      code: " .input-group",
    },
    {
      text: " itself and contents within will automatically resize—no need for repeating the form control size classes on each element.",
    },
  ];
  
  export const multipleInputData = [
    {
      text: "While multiple ",
      code: "<input>",
    },
    {
      text: " itself and contents within will automatically resize—no need for repeating the form control size classes on each element.",
      code: "<input>.",
    },
  ];
  
  export const basicInputGroupData = [
    {
      text: "lace one add-on or button on either side of an input. You may also place one on both sides of an input. Remember to place ",
      code: "<label>",
    },
    {
      text: "s outside the input group.",
    },
  ];
  
  export const variationOfAddonData = [
      {
        text: "Place one add-on or button on either side of an input. You may also place one on both sides of an input. Remember to place ",
        code: "<label>",
      },
      {
        text: "s outside the input group.",
      },
    ];
  
    export const InputMaskData = [
      {
        text: "Input Mask Used In Form-Validations,Forms,Card-Details,And Etc.",
      },
      
    ];
  